<section class="main-section">
  <div class="row">
    <div class="col">
      <div class="row align-items-center">
        <div class="col-6">
        </div>
        <div class="col-md-6 mt-4 mt-md-0 text-right float-right">
          <a *ngIf="user.role === 'ROLE_ADMIN'" routerLink="/admin/adminStockTransfer" class="text-danger p-2 ml-2"><b>Discard</b></a>
          <a *ngIf="user.role === 'WORK_MEN'" routerLink="/admin/workMenOrder" class="text-danger p-2 ml-2"><b>Discard</b></a>
          <button class="btn btn-orange text-white p-2 ml-2" (click)="submitOrderForShipment()" *ngIf="step === 4"><b>Submit</b></button>
        </div>
      </div>
    </div>
  </div>
  <form [hidden]="step !== 1" *ngIf="order.orderStatus == 'TO_PACK' || order.orderStatus == 'SUBMITTED'" >
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Shipping Configurations</h2>
          <div class="row">
            <div class="col-md-8">
              <h6 class="text-black mb-3">Shipping Method</h6>
              <div class="form-radio mr-2 mt-2">
                <input type="radio" name="shippingMethod" id="Parcel" [(ngModel)]="order.shippingMethod" [ngModelOptions]="{standalone: true}" value="PARCEL" required>
                <label for="Parcel">Parcel (standard shipping)</label>
              </div><br><br>
              <div class="form-radio mr-2">
                <input type="radio" name="shippingMethod" id="PALLETIZED" [(ngModel)]="order.shippingMethod" [ngModelOptions]="{standalone: true}" value="PALLETIZED" required>
                <label for="PALLETIZED">Palletized container or LTL (less-than-truckload)</label>
              </div><br><br>
              <div class="form-radio mr-2">
                <input type="radio" name="shippingMethod" id="FULL" [(ngModel)]="order.shippingMethod" [ngModelOptions]="{standalone: true}" value="FULL" required>
                <label for="FULL">Floor loaded container
                  <p class="label-para-size">Labor cost may increase with floor loaded containers</p>
                </label>
              </div>
            </div>
            <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">{{statusText1}}</div>
          </div>

        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 text-right">
        <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
        <button type="submit" (click)="selectPackingConfigure()" class="btn btn-orange ml-2">Next</button>
      </div>
    </div>
  </form>
  <form [hidden]="step !== 2" *ngIf="order.orderStatus == 'TO_PACK' || order.orderStatus == 'SUBMITTED'" >
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Select the Package Type</h2>
          <h6 class="text-black mb-3">How is your inventory configured?</h6>

          <div class="row">
            <div class="col-md-6">

              <div class="form-radio">
                <input type="radio" name="skuConfig" id="SingleSKU" [(ngModel)]="order.productConfig" [ngModelOptions]="{standalone: true}" value="SKU" required>
                <label for="SingleSKU">One SKU per box
                  <p class="label-para-size">Each box contains a single SKU</p>
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-radio">
                <input type="radio" name="skuConfig" id="multipleSKU" [(ngModel)]="order.productConfig" [ngModelOptions]="{standalone: true}" value="MULTI_SKU" required>
                <label for="multipleSKU">Multiple SKUs per box
                  <p class="label-para-size">Each box has 2 or more SKUs</p>
                </label>
              </div>
            </div>
            <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText2">{{statusText2}}</div>

          </div>
        </div>
      </div>
    </div>
    <!--
        <div class="row mt-3">
          <div class="col-6">
            <button type="button"  (click)="backToShippingConfig()"  class="btn btn-cancel">Back</button>
          </div>
          <div class="col-6 text-right">
            <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
            <button type="submit" (click)="selectShipmentConfigure()" class="btn btn-orange ml-2">Next</button>
          </div>
        </div>
    -->
  </form>

  <form [hidden]="step !== 2" *ngIf="order.orderStatus == 'TO_PACK' || order.orderStatus == 'SUBMITTED'">
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Packing Configuration</h2>
          <div id="statusText14"class="invalid-feedback d-block mb-3" *ngIf="statusText14">{{statusText14}}</div>

          <div class="row mt-4">
            <div class="col-md-12" style="overflow-x:auto" *ngIf="order.productConfig === 'SKU'">
              <table class="table packing-table">
                <thead>
                <tr>
                  <th>Name</th>
                  <th>Quantity</th>
                  <th>Quantity/Box</th>
                  <th>No.of Boxes</th>
                  <th>Package Type</th>
                  <th>Box Dimensions (in cm)</th>
                  <th>Weight (in grams)</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let o of order.lines">
                  <tr *ngIf="!showAddShipRow(o)">
                    <td class="align-top" [attr.rowspan]="(!o.shipLines?.length ? 1 : o.shipLines.length)">{{o.productName}}</td>
                    <td class="align-top"  [attr.rowspan]="(!o.shipLines?.length ? 1 : o.shipLines.length)">{{o.quantity}} <img src="/./assets/images/tick.svg" class="float-right" title="Shipment quantity is mathced" style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="showShipIcon(o)"> <img src="/./assets/images/close.svg" class="float-right" title="Shipment quantity is not mathced" style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="!showShipIcon(o) &&( o.qtyPerBoxTmp || o.numOfBoxesTmp || o.shipLines.length>1)"></td>
                    <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(o)" class="form-control" [(ngModel)]="o.qtyPerBoxTmp" onkeypress='return event.charCode >= 48 && event.charCode <= 57' [ngModelOptions]="{standalone: true}" required></td>
                    <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(o)" class="form-control" [(ngModel)]="o.numOfBoxesTmp" onkeypress='return event.charCode >= 48 && event.charCode <= 57' [ngModelOptions]="{standalone: true}" required></td>
                    <td class="bg-color2">
                      <ng-select id="package" [(ngModel)]="o.packageType" [disabled]="showAddShipRow(o)" appendTo="body" (open)="openPackage()" (change)="populateDimensions(o)" [ngModelOptions]="{standalone: true}" required
                                 [items]="package"
                                 bindLabel="packingType"
                                 bindValue="packingType"
                                 placeholder="Package Type">
                      </ng-select>
                    </td>
                    <td class="lwh-box bg-color2">

                      <input type="text" [disabled] = "o.packageType !== 'Custom'"  [(ngModel)]="o.boxHeight" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="L"/>

                      <input type="text" [disabled] = "o.packageType !== 'Custom'" [(ngModel)]="o.boxWidth" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="W"/>

                      <input type="text" [disabled] = "o.packageType !== 'Custom'" [(ngModel)]="o.boxLength" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="H"/>

                    </td>
                    <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(o)" [(ngModel)]="o.boxWeight" appOnlyNumbers class="form-control" [ngModelOptions]="{standalone: true}" required></td>
                    <!--                    <td [attr.rowspan]="(o.shipLines == null ? 0 : o.shipLines.length) + 1">{{o.totalQuantity}}</td>-->
                    <td class="align-middle bg-color2">
                      <a (click)="addShipmentLine(o)"  *ngIf="showAddShipmentBtn(o) " data-toggle="tooltip" data-placement="top" title="Add">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21.34" height="21.34" viewBox="0 0 21.34 21.34">
                          <path id="Icon_ionic-md-add-circle" data-name="Icon ionic-md-add-circle" d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z" transform="translate(-3.375 -3.375)" fill="#ee7125"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  <ng-container *ngFor="let s of o?.shipLines; let j=index;">
                    <tr *ngIf="o?.shipLines?.length && j!==0">
                      <td class="align-top" *ngIf="showAddShipRow(o) && j==1" [attr.rowspan]="(!o.shipLines?.length ? 1 : o.shipLines.length)">{{o.productName}}</td>
                      <td class="align-top" *ngIf="showAddShipRow(o) && j==1" [attr.rowspan]="(!o.shipLines?.length ? 1 : o.shipLines.length)">{{o.quantity}} <img src="/./assets/images/tick.svg" class="float-right" title="Shipment quantity is mathced" style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="showAddShipRow(o)"> <img src="/./assets/images/close.svg" class="float-right" title="Shipment quantity is not mathced" style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="!showAddShipRow(o)"></td>
                      <td><input type="text" disabled [(ngModel)]="s.quantityPerBox" onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control" [ngModelOptions]="{standalone: true}"  required></td>
                      <td><input type="text" disabled [(ngModel)]="s.numberOfBoxes" onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control" [ngModelOptions]="{standalone: true}"  required></td>
                      <td><input type="text" disabled [(ngModel)]="s.packageType" class="form-control w-100" [ngModelOptions]="{standalone: true}"  required></td>
                      <td class="lwh-box">
                        <input type="text" disabled [(ngModel)]="s.boxHeight" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="L"/>
                        <input type="text" disabled [(ngModel)]="s.boxWidth" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="W"/>
                        <input type="text" disabled [(ngModel)]="s.boxLength" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="H"/>
                      </td>
                      <td><input type="text" disabled [(ngModel)]="s.boxWeight"  class="form-control w-120" [ngModelOptions]="{standalone: true}"  required></td>
                      <td><a (click)="removeShipmentLine(o, s)">
                        <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                          <defs><style>.a{fill:#848484;}</style></defs>
                          <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                        </svg>
                      </a></td>
                    </tr>
                  </ng-container>
                </ng-container>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText7">{{statusText7}}</div>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText8">{{statusText8}}</div>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText9">{{statusText9}}</div>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText15">{{statusText15}}</div>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText19">{{statusText19}}</div>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText10">{{statusText10}}</div>
                </tbody>
              </table>
            </div>
            <div class="col-md-12"  *ngIf="order.productConfig === 'MULTI_SKU'">
              <div class="col">
                <div class="inner-box">
                  <div class="col-md-4">
                    <div class="form-group required">
                      <!-- <input type="text" id="numberOfBoxes" [(ngModel)]="numberOfBoxes" (keyup)="changeBox()" class="form-control" [ngModelOptions]="{standalone: true}" required>
                       <label for="numberOfBoxes" class="control-label">Number Of Boxes</label>-->
                      <select class="form-control" id="numberOfBoxes" [(ngModel)]="numberOfBoxesM" [ngModelOptions]="{standalone: true}" (change)="changeBox()"   [ngModelOptions]="{standalone: true}" required>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                      </select>
                      <label class="control-label" for="numberOfBoxes" >Number Of Boxes</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="inner-box">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Product</th>
                      <th>Shipment Qty</th>
                      <th *ngFor="let b of order.lines[0].shipLines; let i=index;">Box {{i+1}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td colspan="3">Package type</td>
                      <td *ngFor="let b of order.lines[0].shipLines">
                        <select class="form-control" id="packagem" [(ngModel)] = "b.packingType" (change) = selectPackType() [ngModelOptions]="{standalone: true}" required>
                          <option *ngFor="let p of package" [ngValue]="p.packingType">{{p.packingType}}</option>
                        </select>
                      </td>
                    </tr>
                    <tr *ngFor="let r of order.lines">

                      <td style ="text-transform:uppercase;">{{r.sku}}</td>
                      <td>{{r.productName|titlecase}}</td>
                      <td>{{r.quantity}} <img src="/./assets/images/tick.svg" class="float-right" title="Shipment quantity is mathced" style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="showIcon(r)"> <img src="/./assets/images/close.svg" class="float-right" title="Shipment quantity is not mathced" style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="!showIcon(r) && fieldsEntered(r)"></td>
                      <ng-container *ngFor="let b of r.shipLines">
                        <td *ngIf="b.productId == r.productId">
                          <input type="text" [(ngModel)] = "b.quantityPerBox" [ngModelOptions]="{standalone: true}" class="form-control">
                        </td>
                      </ng-container>
                      <td></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div id="statusText18"class="invalid-feedback shift-invalid-login d-block mb-3" [hidden]="!statusText18">{{statusText18}}</div>
          <div id="statusText13"class="invalid-feedback d-block shift-invalid-login mb-3" [hidden]="!statusText13">{{statusText13}}</div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <button type="button" (click)="backToShippingConfig()" class="btn btn-cancel">Back</button>
      </div>
      <div class="col-6 text-right">
        <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
        <button type="submit" (click)="proceedShipRockForSE()"  class="btn btn-orange ml-2">save</button>
      </div>
    </div>
  </form>
  <form [hidden]="step !== 3"  *ngIf="(order.orderStatus == 'READY_TO_SHIP' || order.orderStatus == 'AWAITING_CARRIER')">
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Shipping Options</h2>
          <div id="statusText11" class="invalid-feedback d-block shift-invalid-text" [hidden]="!statusText11">{{statusText11}}</div>
          <div class="row mt-2">
            <div class="col-md-8">
              <div class="form-radio form-btn-radio mr-2">
                <input type="radio" id="shift" [(ngModel)]="order.shippingOption" [ngModelOptions]="{standalone: true}"  required value="SHIFT" name="shippingOption">
                <label for="shift">Shift</label>
              </div><br><br>
              <div class="form-radio form-btn-radio mr-2">
                <input type="radio" name="shippingOption" [(ngModel)]="order.shippingOption" [ngModelOptions]="{standalone: true}"  required value="THIRD_PARTY" id="thirdParty">
                <label for="thirdParty">Third Party Carriers</label>
              </div>
              <div name="message" id="errorMessage" class="invalid-feedback d-block shift-invalid-login" [hidden]="!errorMessage">{{errorMessage}}</div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div style="overflow-x:auto;">
                <table class="table" [hidden] = '!showCourierTable'>
                  <thead>
                  <tr>
                    <th>Select</th>
                    <th>Courier Partner</th>
                    <th>Min.weight</th>
                    <th>RTO Charges</th>
                    <th>Price</th>
                    <th>Pickup Available</th>
                    <th>Estimated Delivery</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let co of courier">
                    <td>
                      <div class="form-radio form-shift-radio">
                        <input type="radio" id="{{co.courier_company_id}}" name="courier" (change)="changeCourier(courierId)" [(ngModel)]="courierId" [ngModelOptions]="{standalone: true}" required value="{{co.courier_company_id}}">
                        <label for="{{co.courier_company_id}}"></label>
                      </div>
                    </td>
                    <td>{{co.courier_name}}</td>
                    <td>{{co.min_weight}}</td>
                    <td>{{co.rto_charges}}</td>
                    <td>{{co.rate | currency:'INR'}}</td>
                    <td>{{co.pickup_availability==1? "Yes" :"No"}}</td>
                    <td>{{co.estimated_delivery_days}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
      </div>
      <div class="col-6 text-right">
        <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
        <button type="submit" [disabled]="order.shippingOption == 'THIRD_PARTY' && !showCourierTable" (click)="reviewAndConfirm()" class="btn btn-orange ml-2">Next</button>
      </div>
    </div>
  </form>
  <form [hidden]="step !== 4" *ngIf="order.orderStatus == 'READY_TO_SHIP' || order.orderStatus == 'AWAITING_CARRIER'">
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="text-center">
            <div name="message" id="errorMessage1" class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage1">{{errorMessage1}}</div>
            <h2 class="text-black mb-3 mt-2 review">Review and Confirm</h2>
          </div>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-md-6">
                  <h2 class="text-black mb-2 review">Order Details</h2>
                  <label><b>Order Number :</b><span class="ml-1"></span>{{order.orderNumber}}</label><br>
                  <label><b>Create Date :</b><span class="ml-1"></span>{{order.orderedDate}}</label>
                </div>
              </div>
              <hr class="row-bordered">
              <div class="row">
                <div class="col-md-6">
                  <h2 class="text-black mb-2 review">Customer Details</h2>
                  <label><b>Customer Name :</b><span class="ml-1">{{order.accountOwnerCustomerName|| order.accountOwnerName}}</span></label><br>
                  <label><b>Customer Address :</b><span class="ml-1">{{order.addressText || order.ownerAddressText}}</span></label>
                </div>
              </div>
              <hr class="row-bordered">
              <div class="row">
                <div class="col-md-6">
                  <h2 class="text-black mb-2 review">Source Warehouse Details</h2>
                  <label class="text-black"><b>Warehouse Location :</b><span class="ml-1">{{order.sourceWarehouseName }}</span></label><br>
                  <label><b>Address :</b><span class="ml-1">{{order.warehouseAddressText ||order.sourceWarehouseAddressText}}</span></label>
                </div>
                <div class="col-md-6">
                  <h2 class="text-black mb-2 review">Destination Warehouse Details</h2>
                  <label class="text-black"><b>Warehouse Location :</b><span class="ml-1">{{order.destWarehouseName}}</span></label><br>
                  <label><b>Address :</b><span class="ml-1">{{order.destWarehouseAddressText}}</span></label>
                </div>
              </div>
              <hr class="row-bordered">
              <h2 class="text-black mb-2 review">Shipping Details</h2>
              <div class="row">
                <div class="col-md-6">
                  <label class="text-black mb-2"><b>Shipping Method :</b>
                    <label *ngIf="order.shippingMethod == 'PARCEL'" class="ml-1">Parcel (standard shipping)</label>
                    <label *ngIf="order.shippingMethod == 'PALLETIZED'" class="ml-1">Palletized container or LTL (less-than-truckload)</label>
                    <label *ngIf="order.shippingMethod == 'FULL'" class="ml-1">Floor loaded container</label>
                  </label><br>
                  <label><b>No.of Boxes :</b><span class="ml-1">{{boxesCount}}</span></label><br/>
                </div>
                <div class="col-md-6">
                  <label><b>Configuration :</b>
                    <label *ngIf="order.productConfig == 'SKU'" class="ml-1">One SKU per box</label>
                    <label *ngIf="order.productConfig == 'MULTI_SKU'" class="ml-1">Multiple SKUs per box</label>
                  </label><br>
                  <label class="text-black mb-2"><b>Shipment Type :</b>
                    <label *ngIf="order.shippingOption == 'SHIFT'" class="ml-1">Shift</label>
                    <label *ngIf="order.shippingOption == 'THIRD_PARTY'" class="ml-1">Third Party</label>
                  </label>
                </div>
              </div>
              <hr class="row-bordered">
              <div class="row">
                <div class="col">
                  <h2 class="text-black mb-2 review">Product Details</h2>
                  <table class="table">
                    <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Quantity</th>
                      <th>Quantity Per Box</th>
                      <th>No. of Boxes</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let r of reviewOrder.lines">
                      <tr>
                        <td [attr.rowspan]= "(r.shipLines == null ? 1 : r.shipLines.length)" style ="text-transform:uppercase;">{{r.sku}}</td>
                        <td [attr.rowspan]= "(r.shipLines == null ? 1 : r.shipLines.length)">{{r.productName|titlecase}}</td>
                        <td [attr.rowspan]= "(r.shipLines == null ? 1 : r.shipLines.length)">{{r.quantity}}</td>
                        <td>{{(r.shipLines == null ? 0 : r.shipLines[0].quantityPerBox)}}</td>
                        <td>{{(r.shipLines == null ? 0 : r.shipLines[0].numberOfBoxes)}}</td>
                      </tr>
                      <ng-container *ngFor="let s of r.shipLines;let i= index;">
                        <tr *ngIf="i != 0">
                          <td>{{s.quantityPerBox}}</td>
                          <td>{{s.numberOfBoxes}}</td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form><br><br>
</section>


<!--<div class="form-btn-section" [hidden]="step !== 4" >-->
<!--  <div class="row">-->
<!--    <div class="col-6 text-left">-->
<!--      <button type="button" (click)="backToShipmentOptions()" class="btn btn-cancel">Back</button>-->
<!--    </div>-->
<!--    <div class="col-6 text-right">-->
<!--      <button type="submit" (click)="submitOrderForShipment()" class="btn btn-orange ml-2">Submit</button>-->
<!--    </div>-->
<!--  </div>-->
